import React from 'react';
import { Link } from 'react-router-dom';
import { Camera, User, Palette, ArrowRight } from 'lucide-react';
import { services } from '../data/mock';

const ServicesPage = () => {
  const icons = {
    0: Camera,
    1: User,
    2: Palette
  };

  return (
    <div className="min-h-screen pt-24 md:pt-32 bg-white">
      {/* Header Section */}
      <section className="container-luxury mb-16 md:mb-24">
        <div className="max-w-2xl">
          <h1 className="section-title text-[#111111] mb-6 animate-fade-in-up">
            Services
          </h1>
          <div className="w-16 h-px bg-[#111111] mb-8 animate-fade-in-up animation-delay-1" />
          <p className="body-text text-[#666666] animate-fade-in-up animation-delay-2">
            Des prestations sur mesure pour donner vie à votre vision artistique. 
            Chaque projet est une collaboration unique.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="container-luxury">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          {services.map((service, index) => {
            const IconComponent = icons[index];
            return (
              <div
                key={service.id}
                className="group p-8 lg:p-12 border border-[#EAEAEA] hover:border-[#111111] transition-colors duration-500 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* Icon */}
                <div className="mb-8">
                  <IconComponent 
                    size={32} 
                    strokeWidth={1} 
                    className="text-[#111111]"
                  />
                </div>

                {/* Title */}
                <h3 className="font-serif text-2xl text-[#111111] mb-4">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="body-text text-[#666666] mb-8">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-3 mb-8">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-3">
                      <span className="w-1 h-1 bg-[#111111] rounded-full" />
                      <span className="caption-text text-[#666666]">
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>

                {/* CTA */}
                <div className="pt-8 border-t border-[#EAEAEA]">
                  <span className="nav-link text-[#9A9A9A]">
                    Tarifs sur demande
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA Section */}
      <section className="container-luxury section-spacing-large">
        <div className="bg-[#111111] p-12 md:p-20 text-center">
          <h2 className="font-serif text-2xl md:text-3xl text-white mb-6 animate-fade-in-up">
            Débutons votre projet
          </h2>
          <p className="body-text text-white/70 max-w-xl mx-auto mb-10 animate-fade-in-up animation-delay-1">
            Chaque collaboration commence par une conversation. 
            Parlez-moi de votre vision.
          </p>
          <Link
            to="/contact"
            className="btn-outline-white group inline-flex animate-fade-in-up animation-delay-2"
          >
            Me Contacter
            <ArrowRight size={14} className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
